import RiskAssessment from "./RiskAssessment"
export default RiskAssessment
